export const formatDate = (date, dateStyle = "long") => date.toLocaleDateString(window.document.documentElement.lang, {dateStyle});
export const formatTime = (date, timeStyle = "short") => date.toLocaleTimeString(window.document.documentElement.lang, {timeStyle});
